import { z } from 'zod';
import { listArchetypes } from './archetypes/index.js';
const LocalizedName = z.object({
    legal: z.string().min(1),
    parody: z.string().min(1)
});
export const GroupSchema = z.object({
    id: z.string().regex(/^[a-z0-9_]+$/),
    name: LocalizedName,
    debutYear: z.number().int().min(1990).max(2100),
    colorPrimary: z.string().regex(/^#[0-9A-Fa-f]{6}$/),
    synergy: z.object({
        name: z.string(),
        effect: z.string(),
        amount: z.number()
    })
});
export const MemberSchema = z.object({
    id: z.string().regex(/^[a-z0-9_]+$/),
    groupId: z.string(),
    stageName: LocalizedName,
    role: z.enum(['rapper', 'vocalist', 'dancer', 'visual', 'maknae']),
    rarity: z.enum(['N', 'R', 'SR', 'SSR']),
    stats: z.object({
        hp: z.number().positive(),
        atk: z.number().positive(),
        def: z.number().nonnegative(),
        spd: z.number().positive(),
        crit: z.number().min(0).max(1)
    })
});
export const SkillSchema = z.object({
    id: z.string().regex(/^[a-z0-9_]+$/),
    ownerMemberId: z.string(),
    type: z.enum(['passive', 'active', 'ultimate']),
    archetypeId: z.string().refine((id) => listArchetypes().includes(id), { message: 'unknown archetype' }),
    params: z.record(z.union([z.number(), z.string(), z.boolean()])),
    cooldown: z.number().nonnegative(),
    unlockLevel: z.number().int().min(1),
    flavorName: z.string().min(1),
    flavorText: z.string(),
    sourceReference: z.string().optional()
});
